import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router, UrlTree } from '@angular/router';
import { SplashScreenStateService } from '../common/services/splash-screen-state.service';
import { ConfigService } from '../config/services/config.service';

export const courseGuard: CanActivateFn = () => {
    const router = inject(Router);
    const splashScreenStateService = inject(SplashScreenStateService);
    const configService = inject(ConfigService);

    if (configService.config()?.configuration.features?.course?.enabled) {
        return true;
    }
    const urlTree: UrlTree = router.parseUrl('/member/home');
    splashScreenStateService.stop();
    return new RedirectCommand(urlTree, { skipLocationChange: true });
};
